import React, { useState } from 'react';
import SystemStatsDialog from './SystemStatsDialog';
import type { SystemStatsProps } from './types';

/** The page-level trigger: a link that opens the stats dialog. */
export default function SystemStatsLink({ serverId, pollInterval }: SystemStatsProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* A button, not an anchor: it doesn't navigate, and an <a> without an
          href isn't keyboard-operable. Styled to read as a link. */}
      <button type="button" className="system-stats-link" onClick={() => setOpen(true)}>
        View System Stats
      </button>

      {/* Rendered only while open, rather than mounted and hidden. Unmounting is
          what stops the poll - a hidden dialog would keep hitting the endpoint
          forever after the admin walked away. */}
      {open && (
        <SystemStatsDialog
          serverId={serverId}
          pollInterval={pollInterval}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
